import { compose, pure } from 'recompose';

import EmojiItem from './emojiItem';

const enhance = compose(
  pure,
);
export default enhance(EmojiItem);
